<template>
  <v-dialog max-width="600px" v-model="dialog">
    <template v-slot:activator="{ on: dialog }">
      <v-tooltip top>
        <template v-slot:activator="{ on: tooltip }">
          <v-btn
            icon
            color="green"
            v-if="getIcon"
            v-on="{ ...tooltip, ...dialog }"
            @click="getInvitationLink"
            ><v-icon>link</v-icon>
          </v-btn>
          <v-btn
            v-on="{ ...tooltip, ...dialog }"
            v-if="getButton"
            class="success mr-1"
            @click="getInvitationLink"
            ><v-icon>link</v-icon><span>Order Link</span></v-btn
          >
        </template>
        <span>Get link</span>
      </v-tooltip>
    </template>
    <v-card>
      <v-card-title>
        <h2>Order Invitation</h2>
      </v-card-title>
      <v-card-text>
        <v-form class="px-3" ref="form">
          <v-text-field
            v-model="cartId"
            label="CartId"
            prepend-icon="shopping_cart"
            disabled
          ></v-text-field>
          <v-textarea
            ref="linkTextArea"
            v-model="invitationLink"
            label="CartId"
            prepend-icon="link"
            disabled
            auto-grow
          ></v-textarea>
          <v-spacer></v-spacer>
          <v-btn @click="closeDialog" class="success mx-1 mt-3">Close</v-btn>
          <v-btn @click="copyLink" class="success mx-1 mt-3">Copy</v-btn>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import cartApi from "../modules/cart-api";

export default {
  props: {
    cartId: {
      type: String,
    },
    icon: {
      type: Boolean,
    },
    button: {
      type: Boolean,
    },
  },
  data() {
    return {
      invitationLink: "",
      dialog: false,
    };
  },
  computed: {
    getButton() {
      if (this.button) {
        return true;
      } else {
        return false;
      }
    },
    getIcon() {
      if (this.icon) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    async getInvitationLink() {
      if (this.cartId) {
        let res = await cartApi.getInvitationByCartId(this.cartId);
        this.invitationLink = res;
      } else {
        this.$log.info("skipping link for cart " + this.cartId);
      }
    },
    closeDialog() {
      this.dialog = false;
    },
    async copyLink() {
      let copyRes = false;
      await navigator.clipboard.writeText(this.invitationLink).then(function() {
        copyRes = true;
      }, function(err) {
        console.error('Async: Could not copy text: ', err);
      });
      if (copyRes) this.$toast("Copied address");
      this.dialog = false;
    },
  },
};
</script>
